<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="required">
          {{ $t('studentInsurance.dateOfBirth') }}</label
        >
        <a-date-picker
          v-model="model.date_of_birth"
          valueFormat="YYYY-MM-DD"
          format="DD-MM-YYYY"
          :allowClear="false"
          class="ts-w-full"
        ></a-date-picker>
        <div class="ts-text-red-500 ts-mt-2" v-if="errors.has('date_of_birth')">
          {{ errors.first('date_of_birth') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required"> {{ $t('studentInsurance.reason') }}</label>
        <textarea
          v-model="model.insuration_converted_reason"
          class="form-control"
          :placeholder="$t('studentInsurance.reasonPlaceholder')"
          rows="3"
        ></textarea>
        <div
          class="ts-text-red-500 ts-mt-2"
          v-if="errors.has('insuration_converted_reason')"
        >
          {{ errors.first('insuration_converted_reason') }}
        </div>
      </div>
    </div>
    <div class="row ts-mt-4">
      <div class="col-md-12 ts-flex ts-space-x-2 ts-justify-end">
        <a-button @click.prevent="$emit('close')" type="default">
          {{ $t('cancel') }}
        </a-button>
        <a-button type="primary" @click.prevent="onsubmit" :loading="loading">
          {{ $t('save') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'inseranceConvert',
  props: ['selected'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        date_of_birth: null,
        id: null,
        insuration_converted_reason: ''
      }
    }
  },
  created() {
    this.model.id = this.selected.id
  },
  methods: {
    onsubmit() {
      this.loading = true
      this.$store
        .dispatch('studentInsurance/convertToInsurance', {
          id: this.selected.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
